import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

function AddFileButton(props) {
    const { t } = useTranslation();

    const isMiniSize = useMemo(() => {
        return props.size === "mini";
    }, [props.size]);

    const getAddFileButtonName = () => {
        switch (props.fileType) {
            case "docs":
                return t("dialog.file_dialog.add_docs");
            case "certs":
                return t("dialog.file_dialog.add_cert");
            default:
                return t("dialog.file_dialog.add_file");
        }
    };

    return (
        <Button
            size={isMiniSize ? "small" : props.size}
            variant={props.variant}
            color={props.color}
            onClick={props.onClick}
            sx={props.sx}
            disabled={props.disabled}
            startIcon={<FileUploadIcon />}
            className={isMiniSize ? "mini-button" : undefined}
        >
            {getAddFileButtonName()}
        </Button>
    );
}

AddFileButton.propTypes = {
    sx: PropTypes.object,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    fileType: PropTypes.string,
    disabled: PropTypes.bool,
};

AddFileButton.defaultProps = {
    sx: {},
    fileType: "file",
};

export default AddFileButton;
